import type { CSSTextAlign, CSSTextTransform } from '@ur-solutions/react-components'
import styled from 'styled-components'
import type { HTMLRel, HTMLTarget } from '@/types/html'
import type { CSSFontWeight } from '@/types/style'
import { overloadColor } from '@/utils/style'

export interface ExternalLinkProps {
  href: string
  rel?: HTMLRel
  target?: HTMLTarget
  $hoverDecoration?: string

  $fontSize?: string
  $fontWeight?: CSSFontWeight
  $textAlign?: CSSTextAlign
  $textTransform?: CSSTextTransform
  $lineHeight?: string | number

  $block?: boolean
  $color?: string

  $userSelect?: string
}

export const ExternalLink = styled.a.attrs({
  rel: 'noopener',
  target: '_blank',
})<ExternalLinkProps>`
  text-decoration: none;
  display: ${props => (props.$block ? 'block' : 'inline')};
  color: ${props => overloadColor(props.$color ?? 'link')};

  font-size: ${props => props.$fontSize};
  text-align: ${props => props.$textAlign ?? 'left'};
  text-transform: ${props => props.$textTransform ?? 'none'};
  font-weight: ${props => props.$fontWeight ?? 'normal'};
  line-height: ${props => props.$lineHeight ?? 1.5};

  &:hover {
    text-decoration: ${props => props.$hoverDecoration ?? 'underline'};
  }
`

export const PlainExternalLink = styled(ExternalLink)`
  color: inherit;

  &:hover {
    text-decoration: none;
  }
`
